module.exports = __webpack_public_path__ + "static/media/Hebrew_LiveNow.bafa7206.svg";